import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import logo from '../../images/kslplus/logo_Bird.png'
import logoText from '../../images/kslplus/ltpplus_logo.png'

export default function NavHeader(props) {
  const { showArrowIcon } = props
  const [toggle, setToggle] = useState(false)
  const history = useHistory()

  return (
    <div className="nav-header">
      <div style={{ cursor: 'pointer' }} onClick={() => history.push('/')} className="brand-logo">
        <img className="logo-abbr" src={logo} alt="" />
        <img className="logo-compact" src={logoText} alt="" />
        <img className="brand-title" src={logoText} alt="" />
      </div>
      {/* <div className="nav-control" onClick={() => setToggle(!toggle)}> */}
      <div className="nav-control">
        <div className={`hamburger ${showArrowIcon ? 'is-active' : ''}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  )
}
